/**
 * Normalize FastAPI `detail` for display (string, object, or array of validation errors).
 * Validation errors look like `{ type, loc, msg, input }` and must not be passed to React as children.
 *
 * @param {unknown} detail - `error.response?.data?.detail` from axios
 * @param {string} [fallback='Request failed.']
 * @returns {string}
 */
export function formatApiDetail(detail, fallback = 'Request failed.') {
  if (detail == null || detail === '') return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const lines = detail
      .map((item) => {
        if (item == null) return '';
        if (typeof item === 'string') return item;
        if (typeof item === 'object' && item.msg != null) return String(item.msg);
        try {
          return JSON.stringify(item);
        } catch {
          return String(item);
        }
      })
      .filter(Boolean);
    return lines.length ? lines.join('\n') : fallback;
  }
  if (typeof detail === 'object') {
    if (detail.msg != null) return String(detail.msg);
    try {
      return JSON.stringify(detail);
    } catch {
      return fallback;
    }
  }
  return String(detail);
}
